import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { Features } from '@app/Feature'
import { isFeatureEnabled } from '@app/Feature/Store/selectors'
import { useIntl } from '@app/intl/Intl'
import { Dialog, DialogContent, DialogTrigger } from '@app/lib/disclosure/Dialog/Dialog'
import { useDialog } from '@app/lib/disclosure/Dialog/useDialog'
import { Button } from '@app/lib/inputs/Button/Button'
import { Heading } from '@app/lib/typography/Heading/Heading'
import { AuthSelectors } from '@app/modules/Auth'
import { CourtCaseForm } from '@app/modules/Messages/Components/ProfileBox/CourtCase/CourtCaseForm'
import { CourtCaseQuery } from '@app/queries/CourtCases/CourtCase.queries'
import { Customer } from '@app/queries/CustomerAsLawyer/models'

type CourtCaseDialogProps = {
  customer: Customer | CourtCaseQuery['courtCases']['items'][number]['customer']
}

export const CourtCaseDialog = ({ customer }: CourtCaseDialogProps) => {
  const lawyerId = useSelector(AuthSelectors.getUserId)
  const { openDialog, dialogProps, closeDialog } = useDialog()
  const { formatMessage } = useIntl()
  const isCourtCaseEnabled = useSelector(isFeatureEnabled(Features.COURT_CASE_BUTTON))
  const { courtCaseUuid } = useParams<{ courtCaseUuid: string }>()

  const customerHasActiveMembership = customer.membership && customer.membership.state === 'Active'

  const isSubstitutionLawyer = customer.membership?.lawyerId !== lawyerId
  const isMieterEngelCustomer = !!customer.membership?.membershipTypeUid.includes('mieterengel')
  const hideButtonToSubstituteLawyer = isSubstitutionLawyer && isMieterEngelCustomer

  const showCourtCaseDialog =
    !!isCourtCaseEnabled &&
    customerHasActiveMembership &&
    !hideButtonToSubstituteLawyer &&
    !courtCaseUuid

  if (!showCourtCaseDialog) {
    return null
  }

  return (
    <Dialog {...dialogProps}>
      <DialogTrigger>
        <Button color={'danger'} variant={'solid'} onClick={openDialog}>
          {formatMessage({ id: 'CourtCaseDialog.Button.Open' })}
        </Button>
      </DialogTrigger>

      <DialogContent
        title={<Heading>{formatMessage({ id: 'CourtCaseDialog.Popup.Title' })}</Heading>}
        size='sm'
      >
        <CourtCaseForm closeDialog={closeDialog} isMieterEngelCustomer={isMieterEngelCustomer} />
      </DialogContent>
    </Dialog>
  )
}
